module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_arrow_gold-9b9dc77e3fda52021c439ec62aabee1e.svg";